<app-dashboard-sidemenu></app-dashboard-sidemenu>

<!-- Start Main Content Wrapper Area -->
<div class="main-content d-flex flex-column">

  <app-dashboard-navbar></app-dashboard-navbar>

  <!-- Breadcrumb Area -->
  <div class="breadcrumb-area" *ngFor="let Content of breadcrumb;">
    <h1>{{Content.title}}</h1>
    <ol class="breadcrumb">
      <li class="item"><a routerLink="/">Home</a></li>
      <li class="item"><a routerLink="/dashboard">{{Content.subTitle}}</a></li>
      <li class="item">{{Content.title}}</li>
    </ol>
  </div>
  <!-- Start -->
  <div class="add-listings-box1">
    <div class="row">
      <div class="col-lg-4 col-md-12 form-group">
        <p><strong>Supplier Name: </strong><strong>{{ supplierdata[0]?.supplierName || 'N/A' }}</strong> </p>
      </div>
    </div>
  
  
    <div class="card cost-breaker">
      <form [formGroup]="toolhealthcheckup">
        <div formArrayName="tools">
        <p-table #dt2 [value]="supplierdata" [rows]="10" responsiveLayout="scroll" [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10,20,30,50]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
          <ng-template pTemplate="caption">
          </ng-template>

          <ng-template pTemplate="header">
            <tr>
              <th>S.No.</th>
              <th>BU</th>
              <th>Business Unit</th>
              <th>Tool Type</th>
              <th>Asset Code</th>
              <th>Agreement Date</th>
              <th>Available at your facility</th>
              <th>Initial Estimated life (year)</th>
              <th>Year of production start</th>
              <th>Qty Produced till Date (number)</th>
              <th>Last prod. Dt/month</th>
              <th>Estimated life at present</th>
              <th>Remarks   (If Any)</th>
              <th>Attach Tool Photos</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-tool let-i="rowIndex">
            <tr [formGroupName]="i">
              <td>{{i+1}}</td>
              <td>{{tool.bu || '-'}}</td>
              <td>{{tool.businessUnit || '-'}}</td>
              <td>{{tool.capital || '-'}}</td>
              <td>{{tool.assetCode || '-'}}</td>
              <td>{{ parseDate(tool?.date) ? (parseDate(tool?.date) | date: 'dd-MM-yyyy') : '-' }}</td>

              <td class="form-group">
                <select class="form-control form-select" formControlName="Availableatyourfacility">
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
              </td>
              <td class="form-group">
                <input type="text" class="form-control" placeholder="Initial Estimated life"  formControlName="InitialEstimatedLife" (keypress)="keyPress($event)" />
                
              </td>
            
              <!-- Year of production start -->
              <td class="form-group">
                <input type="text" class="form-control" placeholder="Year of Production Start" formControlName="YearOfProductionStart" (keypress)="keyPress($event)"/>
              </td>
            
              <!-- Qty Produced till Date -->
              <td class="form-group">
                <input type="text" class="form-control" placeholder="Qty Produced till Date"  formControlName="OtyProducedTillDate" (keypress)="keyPress($event)"/>
              </td>
            
              <!-- Last prod. Dt/month -->
              <td class="form-group">
                <input type="text" class="form-control" placeholder="Last Prod. Dt/month"   formControlName="LastProducedMonth" (keypress)="keyPress($event)" />
              </td>
            
              <!-- Estimated life at present (balance) -->
              <td class="form-group">
                <input type="text" class="form-control" placeholder="Life at Present (Balance)" formControlName="EstimatedLifeAtPresent" (keypress)="keyPress($event)"/>
              </td>
              <td class="form-group">
                <input type="text" class="form-control" placeholder="remarks"   formControlName="Remarks"  />
              </td>
              <td style="display: flex; align-items: center; gap: 10px;">
                <input type="file" class="form-control" 
                  (change)="uploadDoc($event, 'add_doc', i)" />
                <span *ngIf="uploadedFiles[i]">
                  {{ uploadedFiles[i]?.name }}
                </span>
                <img *ngIf="isImageFile(uploadedFiles[i]) && imagePreviews[i]" [src]="imagePreviews[i]" alt="Preview"
                  style="width: 50px; height: 50px; object-fit: cover; border-radius: 5px; border: 1px solid #ccc; cursor: pointer;"
                  (click)="openPreviewDialog(imagePreviews[i])" />
             
                <button *ngIf="imagePreviews[i]" (click)="deleteImage(i)" pButton pRipple type="button"
                  icon="bx bx-trash" class="p-button-rounded p-button-danger
                    p-button-text"></button>

              </td>
             


            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6">No data found.</td>
            </tr>
          </ng-template>

        </p-table>
      </div>
        <div class="text-right add-listings-btn">
          <div class="form-group">
            <button class="btn btn-primary" style="margin-right:5px !important;"
              [disabled]="isdisabled"  (click)="onSubmit()">Submit</button>
            <!-- <button (click)="openagreement()" class="btn btn-primary"
            style="margin-right:5px !important;">Generate</button> -->
          </div>
        </div>
      </form>

    </div>
  </div>
 
</div>
<p-dialog [(visible)]="isDialogVisible" [modal]="true" [closable]="true" header="Image Preview"
[style]="{width: '400px'}">
<img [src]="previewImage" alt="Preview" style="width: 100%; max-height: 400px; object-fit: contain;">
</p-dialog>